/**
 * Conflict Stats Component
 * 
 * Displays a grid of stat cards showing:
 * - Critical conflicts count
 * - High/Urgent conflicts count
 * - Medium conflicts count
 * - Auto-resolved count (this week)
 */

import React from "react";
import { tWithKeyAttr as t } from "../../../../i18nHelper";
import { IConflictStats } from "../../types/conflictsDetector.types";
import styles from "../../appointmentsPage.module.css";

interface IConflictStatsProps {
  stats: IConflictStats;
}

const ConflictStatsCard: React.FC<{
  label: string;
  value: number;
  description: string;
  severity: "critical" | "high" | "medium" | "success";
  icon: string;
}> = ({ label, value, description, severity, icon }) => {
  return (
    <div className={`${styles.conflictStatCard} ${styles[`conflictStatCard${severity.charAt(0).toUpperCase() + severity.slice(1)}`]}`}>
      <div className={styles.conflictStatHeader}>
        <div className={styles.conflictStatLabel}>{label}</div>
        <div className={`${styles.conflictStatIcon} ${styles[`conflictStatIcon${severity.charAt(0).toUpperCase() + severity.slice(1)}`]}`}>
          {icon}
        </div>
      </div>
      <div className={styles.conflictStatValue}>{value}</div>
      <div className={styles.conflictStatDescription}>{description}</div>
    </div>
  );
};

const ConflictStats: React.FC<IConflictStatsProps> = ({ stats }) => {
  return (
    <div className={styles.conflictStatsGrid}>
      <ConflictStatsCard
        label={t("CONFLICTS_STAT_CRITICAL")}
        value={stats.critical}
        description={t("CONFLICTS_STAT_CRITICAL_DESC")}
        severity="critical"
        icon="🚨"
      />
      <ConflictStatsCard
        label={t("CONFLICTS_STAT_HIGH")}
        value={stats.high}
        description={t("CONFLICTS_STAT_HIGH_DESC")}
        severity="high"
        icon="⚠️"
      />
      <ConflictStatsCard
        label={t("CONFLICTS_STAT_MEDIUM")}
        value={stats.medium}
        description={t("CONFLICTS_STAT_MEDIUM_DESC")}
        severity="medium"
        icon="ℹ️"
      />
      <ConflictStatsCard
        label={t("CONFLICTS_STAT_RESOLVED")}
        value={stats.autoResolved}
        description={t(stats.autoResolvedPeriod)}
        severity="success"
        icon="✓"
      />
    </div>
  );
};

export default ConflictStats;
